import { CrossIcon } from "@t8891/icon";
import { Button, Mask } from "@t8891/pc";
import React from "react";

const AgreeModal: React.FC<any> = ({ visibleAgree, onClose, onClick }) => {
  return (
    <div id='AgreeModal'>
      <Mask getContainer={document.body} visible={visibleAgree} style={{ "--z-index": "2000" }} destroyOnClose={false}>
        <div className='flex items-center justify-center h-screen relative'>
          <div className='w-500 bg-white pb-20 relative'>
            <CrossIcon onClick={onClose} size={48} className='absolute right-10 top-10 z-1 cursor-pointer' />
            <div className='text-20 text-balck font-medium text-center mb-14 mt-34'>推薦3家為您報價，買車更實惠</div>
            <div className='px-30'>
              <div className='text-[#999] text-14 mt-24 my-auto relative flex'>
                <div className='flex-1'>
                  我已仔細閱讀並同意
                  <a href={"https://www.8891.com.tw/help-sev.html"} className='text-[#999] underline' target='_blank'>
                    《服務條款》
                  </a>
                  、
                  <a href={"https://www.8891.com.tw/help-article-426.html"} target='_blank'>
                    《用戶須知》
                  </a>
                  、
                  <a
                    href={"https://www.8891.com.tw/help-laimer.html"}
                    className='text-[#999] underline'
                    target='_blank'
                  >
                    《免責聲明》
                  </a>
                  、
                  <a href={"https://www.8891.com.tw/help-pris.html"} className='text-[#999] underline' target='_blank'>
                    《隱私權聲明》
                  </a>
                  、
                  <a
                    href={`https://www.8891.com.tw/help-article-442.html`}
                    className='text-[#999] underline'
                    target='_blank'
                  >
                    《一鍵詢價服務說明》
                  </a>
                  等所載內容；本功能由數字科技與數字廣告共同舉辦，點擊代表您同意將個人資料傳送給您所詢價廠牌對應經銷商等相關廠商。
                </div>
              </div>
              <div
                onClick={onClick}
                className='w-full h-50 bg-[#FF4433] text-20 rounded-24 flex items-center justify-center mt-26 text-white cursor-pointer'
              >
                同意並獲取報價
              </div>
            </div>
          </div>
        </div>
      </Mask>
    </div>
  );
};

export default AgreeModal;
